import {useRef, useState} from 'react';

interface useDraggingDetectionProps<T> {
    onDraggingStop: (data: T) => void;
}

type UseDraggingDetectionReturn<T> = [
    (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void,
    (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void,
    (data: T) => void
];

function useDraggingDetection<T>(props: useDraggingDetectionProps<T>): UseDraggingDetectionReturn<T> {
    const {onDraggingStop} = props;

    const [isDragging, setIsDragging] = useState(false);

    const dragStartPosition = useRef({x: 0, y: 0});

    const handleMouseDown = (event: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
        dragStartPosition.current = {x: event.clientX, y: event.clientY};
        setIsDragging(false);
    };

    const handleMouseMove = (event: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
        const distanceX = Math.abs(event.clientX - dragStartPosition.current.x);
        const distanceY = Math.abs(event.clientY - dragStartPosition.current.y);
        if (distanceX > 5 || distanceY > 5) {
            setIsDragging(true);
        }
    };

    const handleMouseUp = (data: T): void => {
        if (!isDragging) {
            onDraggingStop(data);
        }
        setIsDragging(false);
    };

    return [handleMouseDown, handleMouseMove, handleMouseUp];
}

export default useDraggingDetection;
